import React from 'react';
import type { IncidentDrawerDetailScope } from './incidentDrawerDetailTypes';
import { IncidentDrawerRepresentativeEvidenceIntro } from './IncidentDrawerRepresentativeEvidenceIntro';
import { IncidentDrawerDetailStep2Status } from './IncidentDrawerDetailStep2Status';
import { IncidentDrawerDetailStep2Snapshot } from './IncidentDrawerDetailStep2Snapshot';
import { IncidentDrawerDetailStep2Clip } from './IncidentDrawerDetailStep2Clip';

export function IncidentDrawerDetailStep2Evidence({ scope }: { scope: IncidentDrawerDetailScope }) {
  return (
    <>
      <IncidentDrawerRepresentativeEvidenceIntro scope={scope} />
      <IncidentDrawerDetailStep2Status scope={scope} />
      <IncidentDrawerDetailStep2Snapshot scope={scope} />
      <IncidentDrawerDetailStep2Clip scope={scope} />
    </>
  );
}
